// extracted by mini-css-extract-plugin
export default {"ShopItemDocument":"ShopItemDocument_ShopItemDocument__2C4Bm","deleteIcon":"ShopItemDocument_deleteIcon__QLPxy"};